import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_nInput from "./gui/GUIset_nInput";

const DiceThrow = () => {
	useEffect(() => {
		document.title =
			"Dice Throw Problem: find the number of ways to get the targeted sum";
	}, []);

	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	// const [inputFields, setInputFields] = useState([
	// 	{ label: "# of Faces", text: "6" },
	// 	{ label: "# of Dices", text: "4" },
	// 	{ label: "Targeted Sum", text: "16" },
	// ]);
	// const [inputFields, setInputFields] = useState([
	// 	{ label: "# of Faces", text: "4" },
	// 	{ label: "# of Dices", text: "3" },
	// 	{ label: "Targeted Sum", text: "5" },
	// ]);
	const [inputFields, setInputFields] = useState([
		{ label: "Targeted Sum", text: "8" },
		{ label: "# of Faces", text: "6" },
		{ label: "# of Dices", text: "3" },
	]);

	const handleButtonClick = (inputs) => {
		// console.log("handle" + inputs.toString());
		if (inputs[0] == "" || inputs[1] == "" || inputs[2] == "") return;
		s = parseInt(inputs[0]);
		f = parseInt(inputs[1]);
		d = parseInt(inputs[2]);
		//------------
		process();
		//------------
		BuildResult();
		memory = [];
	};

	var txt_time = "";
	var memory = []; // int[][]
	var result = 0;
	var f;
	var d;
	var s;
	var print_count = 0;
	var txt_result = "";

	function process() {
		memory = T.getMatrix(f + 1, s + 1, -9999);
		//------------
		Timer.start();
		result = findWay(d, 0);
		txt_time = Timer.stop_print();
		//------------
		print_count = 0;
		txt_result = "";
		findWay_ToPrint(d, 0, []);
	}

	//add item from List 1 to List 2, sum of list 2 is sum
	function findWay(dices, accum) {
		if (dices == 0) return 0; //no dices left
		if (accum + dices > s) return 0; //exceed
		if (dices == 1 && accum + f >= s) return 1; //last dice & expected value
		if (memory[dices][accum] >= 0) return memory[dices][accum];
		var total = 0;
		for (var i = 1; i <= f; i++) {
			total += findWay(dices - 1, accum + i);
		}
		memory[dices][accum] = total;
		return total;
	}

	//add item from List 1 to List 2, sum of list 2 is sum
	function findWay_ToPrint(dices, accum, list) {
		// console.log("test " + dices + " _ " + accum + " > " + list.toString());
		if (memory[dices][accum] >= 0) {
			if (memory[dices][accum] < 1) return;
		}
		if (dices == 0) return; //no dices left
		if (accum + dices > s) return; //exceed
		if (dices == 1 && accum + f >= s) {
			//last dice & expected value
			var last = s - accum;
			if (print_count > 0) txt_result += "\n";
			print_count++;
			txt_result += print_count + " : " + list.toString() + "," + last;
			return;
		}
		var total = 0;
		for (var i = 1; i <= f; i++) {
			total += findWay_ToPrint(dices - 1, accum + i, T.arr_cloneAdd(list, i));
		}
		return total;
	}

	function BuildResult() {
		var possible_ways = Math.pow(f,d);
		var p = T.roundToFix(result/possible_ways,4);
		var txt = `There are ${result} ways to get ${s} from rolling ${f}-face dice for ${d} times.`;
		txt += `\nProbability: ${result}/${possible_ways} = ${p}`;
		// // console.log("CHECK: \n" + T.matrix_print(memory));
		var part1 = Template.simple3size("key1", "Result", txt, txt_time, 22, 20, 17);
		var part2 = Template.simple00("key2", 1, "Possible Combinations", txt_result, 20, 18);
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	return (
		<GUIset_nInput
			// noHeader = {true}
			title={"Dice Throw Problem"}
			// desc={"There are d dice each having f faces. We need to find the number of ways in which we can get sum s from the faces when the dice are rolled"}
			desc_v2={
				<div>
					There are <i>d</i> dice each having <i>f</i> faces (numbers: 1 to <i>f</i>).
					Find the number of ways in which we can get sum <i>s</i> from the
					faces when the dice is rolled.
				</div>
			}
			inputFields={inputFields}
			handleButtonClick={handleButtonClick}
			partResult={partResult}
			//
			style={1}
			n={1}
			txtButton={"Calculate"}
			width1={220}
			but_marginLeft={200}
		/>
	);
};

export default DiceThrow;

//------------------------------------------------

// const [guiTxt1, guiTxtChange1] = useState("2"); //int
// const [guiTxt2, guiTxtChange2] = useState("10");
// const [guiTxt3, guiTxtChange3] = useState("10");
// //
// const [inputFields, setInputFields] = useState([
// 	{ label: "# of Dice", text: guiTxt1, textChange: guiTxtChange1 },
// 	{ label: "# of Faces", text: guiTxt2, textChange: guiTxtChange2 },
// 	{ label: "Targeted Sum", text: guiTxt3, textChange: guiTxtChange3}
// ]);
// function handleTextChange(index, v) {
// 	console.log("B " + index + "_" + guiTxt1 + " > " + v);
// 	if(index == 0){ guiTxtChange1(v);}
// 	// guiTxtChange3("test");
// 	console.log("A " + index + "_" + guiTxt1);
// 	// setInputFields(inputFields.push([]));
// }
